<template>
  <ClientOnly>
    <DmModal
      class="garage-here-maps-modal"
      :title="garage?.name"
      :subtitle="subtitle"
      v-model="modals.map"
      v-if="modals.map"
    >
      <div class="mt-3">
        <div id="mapContainer"></div>
        <a
          class="garage-here-maps-modal__gmap"
          target="_blank"
          :href="`https://www.google.com/maps/dir//${garage?.lat},${garage?.lng}/`"
        >
          <NuxtImg
            src="/_nuxt/pin.svg"
            height="20px"
            width="20px"
            alt="Wyznacz trasę"
          />
          Wyznacz trasę
        </a>
      </div>
    </DmModal>
  </ClientOnly>
</template>

<script setup lang="ts">
import type { GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead } from '~/api/docs/api';
import { DmModal } from '@dobrymechanik/vue-ui-v2';
import { Loader } from '@googlemaps/js-api-loader';

declare global {
  interface Window { H: any; }
}

interface IProps {
  garage?: GarageJsonldGarageReadGarageReadIdGarageReadNameGarageSlugHistoryReadSuggestedGarageRead;
  modals: any;
}

interface IEmits {
  (name: 'close'): void;
}

// data
let map: google.maps.Map;
const loader = new Loader({
  apiKey: 'AIzaSyAUckYPlO2xJI9owlV5nr_7Yfl7mk96G4A',
  libraries: ["maps"]
});

// props
const props = defineProps<IProps>();

// computed
const subtitle = computed(() => {
  return props.garage?.address || '' + props.garage?.city;
});

// methods
const initMap = async (): Promise<void> => {
  const { Map } = await loader.importLibrary('maps');

  map = new Map(document.getElementById('mapContainer') as HTMLElement, {
    mapId: '1c6301bdb7363db',
    center: { lat: Number(props.garage?.lat) || 52.248, lng: Number(props.garage?.lng) || 21.009 },
    zoom: 15,
    minZoom: 6,
    maxZoom: 20,
    mapTypeControl: false,
    scaleControl: false,
    fullscreenControl: false,
    zoomControl: false,
    streetViewControl: false,
    gestureHandling: 'greedy',
    fullscreenControlOptions: {
      position: 6
    }
  });

  const { AdvancedMarkerElement, PinElement } = await google.maps.importLibrary("marker") as google.maps.MarkerLibrary;


  const pinElement = new PinElement({
    background: '#2470e0',
    borderColor: '#ffffff',
    glyphColor: '#ffffff',
    scale: 1.3
  });

  const marker = new AdvancedMarkerElement({
    map: map,
    position: {
      "lat": Number(props.garage?.lat),
      "lng": Number(props.garage?.lng)
    },
    content: pinElement.element,
    gmpClickable: true
  });
};



// life-cycle
onMounted(async () => {
  initMap();
});
</script>

<style lang="scss">
@import url('assets/styles/components/garage-here-maps-modal.scss');

.garage-here-maps-modal {
  .modal__slot {
    width: auto;
  }
}
</style>